import { inferAssetRootFromLoadedPacks } from '../../utils/packAssetRoot';

const CUSTOM_PSPDF_STYLESHEET_PATH = 'pspdfkit-lib/custom-viewer-v1.css';
const LEGACY_PRODUCTION_PSPDF_STYLESHEET_URL = `https://static.medsender.com/${CUSTOM_PSPDF_STYLESHEET_PATH}`;
const LEGACY_PRODUCTION_PSPDF_BASE_URL = 'https://static-3.medsender.com/';
const LEGACY_STAGING_PSPDF_BASE_URL = 'https://static-2.medsender.com/';

const getEnvHost = () => window.location.hostname.split('.')[0];
export { inferAssetRootFromLoadedPacks };

export const getPSPDFBaseUrl = () => {
  const { protocol: currentProtocol, host, hostname } = window.location;

  if (currentProtocol === 'http:') {
    return `${currentProtocol}//${host}/`;
  }
  const envHost = hostname.split('.')[0];

  // QA serves PSPDFKit locally to avoid CDN CORS issues.
  if (envHost === 'qa') {
    return `${currentProtocol}//${host}/`;
  }

  // Prefer the per-deploy versioned asset root inferred from the loaded packs
  // (e.g. https://cdn.medsender.com/assets/<sha>/). If inference fails — a
  // degraded edge case where no pack tag is present — fall back to same-origin
  // rather than the legacy AWS CloudFront origins (static-3 / static-2
  // .medsender.com), which are being decommissioned. Same-origin matches the
  // http:/qa branches above and resolves via the in-pod nginx sidecar serving
  // pspdfkit-lib from the baked-in /public.
  return inferAssetRootFromLoadedPacks() || `${currentProtocol}//${host}/`;
};

export const getPSPDFStylesheetUrl = () => {
  const { protocol: currentProtocol, host } = window.location;
  const inferredAssetRoot = inferAssetRootFromLoadedPacks();

  if (currentProtocol === 'http:' || getEnvHost() === 'qa') {
    return `${currentProtocol}//${host}/${CUSTOM_PSPDF_STYLESHEET_PATH}`;
  }

  if (inferredAssetRoot) {
    if ([LEGACY_PRODUCTION_PSPDF_BASE_URL, LEGACY_STAGING_PSPDF_BASE_URL].includes(inferredAssetRoot)) {
      return LEGACY_PRODUCTION_PSPDF_STYLESHEET_URL;
    }

    return `${inferredAssetRoot}${CUSTOM_PSPDF_STYLESHEET_PATH}`;
  }

  if (['app', 'staging'].includes(getEnvHost())) {
    return LEGACY_PRODUCTION_PSPDF_STYLESHEET_URL;
  }

  return `${getPSPDFBaseUrl()}${CUSTOM_PSPDF_STYLESHEET_PATH}`;
};

export const getPSPDFLicenseKey = () => {
  const { hostname } = window.location;

  if (hostname === 'qa.medsender.com') {
    return undefined;
  }

  if (hostname === 'staging.medsender.com') {
    return process.env.STAGING_PSPDFKIT_KEY;
  }

  return process.env.PRODUCTION_PSPDFKIT_KEY;
};
